module.exports = __webpack_public_path__ + "img/Metal.74e3ff0d.jpg";